import { getDomainImageUrl, handleImageError } from "../../service/utils/domainUtils";
import { formatDate } from "../../service/utils/formatters";

/**
 * MODAL DE DÉTAILS - Affiche les détails complets d'un domaine
 * @param {Object} props
 * @param {Object} props.domain - Données du domaine
 * @param {Function} props.onClose - Callback fermeture
 */
const DomainDetailsModal = ({ domain, onClose }) => {
  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-bold">{domain.name}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          
          <div className="modal-body">
            <div className="row">
              <div className="col-md-6">
                <div className="domain-image-large mb-4">
                  <img
                    src={getDomainImageUrl(domain.photo)}
                    alt={domain.name}
                    className="img-fluid rounded-3 shadow-sm"
                    onError={handleImageError}
                  />
                </div>
              </div>
              
              <div className="col-md-6">
                <div className="domain-info">
                  <div className="mb-3">
                    <label className="fw-semibold text-muted small">Email</label>
                    <p>
                      <a href={`mailto:${domain.email}`} className="text-primary text-decoration-none">
                        {domain.email}
                      </a>
                    </p>
                  </div>
                  
                  <div className="mb-3">
                    <label className="fw-semibold text-muted small">Description</label>
                    <p className="text-dark">{domain.description}</p>
                  </div>
                  
                  <div className="row">
                    <div className="col-6">
                      <label className="fw-semibold text-muted small">Créé le</label>
                      <p>{formatDate(domain.creationDate)}</p>
                    </div>
                    
                    <div className="col-6">
                      <label className="fw-semibold text-muted small">Dernière mise à jour</label>
                      <p>{formatDate(domain.lastUpdateDate)}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DomainDetailsModal;